// extracted by mini-css-extract-plugin
module.exports = {"videoPlayer":"Player_videoPlayer__lu3fb","videoBigPlayer":"Player_videoBigPlayer__2Hd0n"};